import { Injectable } from '@angular/core';
import { GridComponent, PdfExportProperties } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';

@Injectable({
  providedIn: 'root'
})
export class ToolbarService {

  constructor() { }

  handleExport(args: ClickEventArgs, grid: GridComponent) {
    let id: string = grid.element.id;

    if(args.item?.id === id + '_pdfexport' || args.item?.id === 'pdfexport') {
      const pdfExportProperties: PdfExportProperties = {
        pageSize: 'A4',
        pageOrientation: 'Landscape'
      };
      
      grid.pdfExport(pdfExportProperties);
      grid.refreshColumns();
    } else if(args.item?.id === id + '_excelexport' || args.item?.id === 'excelexport') {

      grid.excelExport();
      grid.refreshColumns();

    } else if(args.item?.id === id + '_csvexport' || args.item?.id === 'csvexport') {
      grid.csvExport();
      grid.refreshColumns();
    } 
  }
}
